import { SortSpecsBuilder } from '@bbraun/shared/util-lang';

export function serializeTypedSort(sort: SortSpecsBuilder<unknown>) {
  return sort.specs
    .map((s) => (s.desc ? `-${s.property.join('.')}` : s.property.join('.')))
    .join(',');
}
